import { render, staticRenderFns } from "./InstructorChoiceModal.vue?vue&type=template&id=0f5086ce&scoped=true"
import script from "./InstructorChoiceModal.vue?vue&type=script&lang=js"
export * from "./InstructorChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./InstructorChoiceModal.vue?vue&type=style&index=0&id=0f5086ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5086ce",
  null
  
)

export default component.exports